<template>
  {{ dataComputed }}
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  data: string | number | boolean | null;
  rawData?: Record<string, any>;
}

const props = defineProps<Props>();

const dataComputed = computed(() => {
  if (typeof props.data === 'number') {
    return props.data.toLocaleString();
  } else {
    return props.data;
  }
});
</script>
